<app-menu-common url="home"></app-menu-common>

<div class="pageheader flexcolumn">
  <section class="flexrow">
    <div class="grey pagetitle">Identification</div>
  </section>
</div>

<div class="pagecontent flexcolumn" style="align-items: center; justify-content: center; min-height: 60vh; padding: 2rem;">

  <mat-card class="login-card" style="width: 100%; max-width: 420px; padding: 2.5rem; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.08); background: #ffffff;">
    <mat-card-content class="flexcolumn" style="gap: 20px;">

      <div class="flexcolumn" style="align-items: center; gap: 10px; margin-bottom: 1.5rem;">
        <div style="background-color: #f1f5f9; padding: 16px; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
          <i class="material-icons" style="font-size: 3rem; color: #1a5fb4;">lock_open</i>
        </div>
        <h2 style="margin: 0; font-weight: 600; color: #1e293b;">Accès Mercalink</h2>
        <p class="grey" style="margin: 0; font-size: 0.9rem; text-align: center;">Saisissez vos identifiants pour vous connecter</p>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form flexcolumn" id="loginform" style="gap: 15px;">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Identifiant</mat-label>
          <i class="material-icons" matPrefix style="margin-right: 8px; color: #64748b; vertical-align: middle;">account_circle</i>
          <input matInput placeholder="Login" formControlName="username" #login autofocus id="login" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Mot de passe</mat-label>
          <i class="material-icons" matPrefix style="margin-right: 8px; color: #64748b; vertical-align: middle;">lock</i>
          <input matInput type="password" placeholder="Password" formControlName="password" id="password" />
        </mat-form-field>

        <button mat-flat-button type="submit" [disabled]="form.invalid || loading" color="primary" style="height: 48px; font-weight: 500; font-size: 1.05rem; border-radius: 8px; margin-top: 1rem; width: 100%;" id="connexion_button">
          @if (!loading) {
            <span>Se connecter</span>
          }
          @if (loading) {
            <span>Connexion en cours...</span>
          }
        </button>
      </form>
    </mat-card-content>
  </mat-card>

  <app-offline-banner></app-offline-banner>
</div>